import { RequestForQuoteGatewayMessage } from '../../../types/RequestForQuoteGatewayMessage';
import { RfqExportRequest } from '../../common/api/clients/export.api';

export const createRfqExportRequest = (rfq: RequestForQuoteGatewayMessage): RfqExportRequest => {
    if (!rfq.orderNumber) {
        throw new Error('RFQ export requires an order number');
    }
    if (!rfq.orderState) {
        throw new Error('RFQ export requires an order state');
    }
    if (!rfq.items) {
        throw new Error('RFQ export requires items');
    }
    if (!rfq.type) {
        throw new Error('RFQ export requires a type');
    }

    const orderNumber = rfq.orderNumber;
    const orderState = rfq.orderState;
    const items = rfq.items;
    const type = rfq.type;

    return {
        orderNumber,
        type,
        vesselId: rfq.vesselId,
        portId: rfq.portId,
        customerId: rfq.customerId,
        supplierId: rfq.supplierId,
        state: orderState,
        items: items.map((item) => ({
            productId: item.productId,
            baseProductId: item.baseProductId,
            packType: item.packType,
            unitSize: item.unitSize,
            units: item.units,
            unit: item.unit,
            volume: item.volume,
            deleted: item.deleted,
        })),
        samplekits: rfq.samplekits?.length
            ? rfq.samplekits.map((samplekit) => ({
                  name: samplekit.name,
                  quantity: samplekit.quantity,
                  deleted: samplekit.deleted,
              }))
            : undefined,
        dateDelivery: rfq.dateDelivery,
        agentId: rfq.agentId,
        buyerReference: rfq.buyerReference,
        offerIds: rfq.offers.map((offer) => offer.id),
    };
};
